import styles from "@/app/styles/components/pages/blog/blog-post-preview.module.scss";
import Link from "next/link";
import Date from "../../common/Date";
import {FormattedMessage} from "react-intl";
import {getCDNImage} from "@/app/utils/ImageUtil";
import Image from "next/image";

const BlogPostPreview = ({ post, categories }) => {

  const categoriesId = `${post?.categories}`;
  const categoriesString = `${categoriesId}`;
  const categoriesArray = categoriesString.split(',');

  const getCategoryById = (id, categories) => {
      return categories?.find(x => x.id == id)?.name
  }

  return (
      <article className={styles.oneItem}>
        <div className={styles.imageDiv}>
            <div className={styles.categoriesArrayContainer}>
                {categoriesArray.map((item) => (
                  <div className={styles.oneItemCat} key={item} id={item}>
                    <p className={styles.postCategory}> {getCategoryById(item, categories)} </p>
                  </div>
                ))}
            </div>
            <div className={styles.imageContainer}>
              <div className={styles.bgImage}>
                  <Image src={getCDNImage(post?.fimg_url)} alt={post?.title.rendered}
                         fill
                         quality={90}
                  />
              </div>
              <Link href={"/blog/" + post.slug} className={styles.postImageLink}></Link>
            </div>
        </div>
        <Link href={"/blog/" + post.slug}>
          <h2 className={styles.postTitle}>{post?.title.rendered}</h2>
        </Link>
        <div className={styles.excerptContent}>
          <div
            dangerouslySetInnerHTML={{ __html: post.excerpt.rendered }}
            className={styles.oneItemContent}
          ></div>
          <Link href={"/blog/" + post.slug} className={styles.readMore}>
            <FormattedMessage id={'components.pages.blog.blogPostPreview.readMore'}>
              {'components.pages.blog.blogPostPreview.readMore'}
            </FormattedMessage>
          </Link>
        </div>
        <div>
          <p className={styles.postDate}>
            <Date dateString={post?.date} />
          </p>
        </div>
      </article>
  );
};

export default BlogPostPreview;
